// src/Common/utils/dataMappingUtils.js

import { Position } from "reactflow";

// Helper function to recursively generate nodes and edges
export const createNodesAndEdgesFromSchema = (
    schema,
    parentId,
    xOffset = 0,
    level = 1,
    y = 90,
    isSource = true,
    nodeYIncrement = 60,
    sourceRootNodeX = 510,
    isTrigger = false,
    isSourceRequest = false,
    parentXPosition = null // Add parentXPosition as a parameter
) => {
    const newNodes = [];
    const newEdges = [];
    let nextY = y;
    let childX;

    // Calculate the default childX based on the level and isSource
    if (isTrigger) {
        childX = 10 + level * xOffset;
        // console.log(schema)

    } else if (isSourceRequest) {
        //childX = sourceRootNodeX - level * xOffset;
    } else if (parentId.startsWith("source-response")) {
        // console.log(level)
        childX = parentXPosition + level * 100;//level * xOffset ;//: 500 - level * xOffset + 200) + sourceRootNodeX;
        // console.log(childX);
    } if (parentId.startsWith("source-request") || parentId.startsWith("destination-request")) {
        childX = parentXPosition - 150;
    }

    // Adjust childX if parentId is "source-request" or "destination-request"
    if (parentId.startsWith("destination-response")) {
        childX = parentXPosition + 100; // Increased offset to 200
    }

    // Adjust childX if parentId is "source-request" or "destination-request"
    if (parentId.startsWith("trigger-response")) {
        childX = parentXPosition - 100; // Increased offset to 200
    }

    let sourceHandle = "dt-a"; // Default: Right
    let targetHandle = "dt-b"; // Default: Left
    let sourcePosition = Position.Right; // Default: Right
    let targetPosition = Position.Left; // Default: Left

    //Invert the handles and positions for source-request and destination-request
    if (parentId === "source-request" || parentId === "destination-request") {
        sourceHandle = "dt-b"; // Left
        targetHandle = "dt-a"; // Right
        sourcePosition = Position.Left;
        targetPosition = Position.Right;
    }

    if (parentId === "source") {
        sourceHandle = "dt-b"; // Left
        targetHandle = "dt-a"; // Right
        sourcePosition = Position.Left;
        targetPosition = Position.Right;
    }

    // Check if schema and schema.properties are defined
    if (schema && schema.properties) {
        for (const key in schema.properties) {
            const property = schema.properties[key];
            // Check if property is defined
            if (property) {
                const nodeId = `${parentId}-${key}`;

                newNodes.push({
                    id: nodeId,
                    type: "custom",
                    data: { label: key, type: property.type },
                    position: { x: childX, y: nextY },
                    sourcePosition: sourcePosition,
                    targetPosition: targetPosition,
                    isConnectable: true,
                });

                // Connect all child nodes to their parent
                //Connect child to its parent only if it is not a root node
                if (parentId !== "source-request" && parentId !== "destination-request" && parentId !== "trigger-response") {
                    // console.log(parentId)

                    // newEdges.push({
                    //     id: `e-${parentId}-${nodeId}`,
                    //     source: parentId,
                    //     sourceHandle: sourceHandle,
                    //     target: nodeId,
                    //     targetHandle: targetHandle,
                    //     type: "simplebezier",
                    //     style: { strokeWidth: 1, stroke: "#000" },
                    // });
                }

                if (parentId === "trigger" || parentId.startsWith("trigger-")) {
                    if (parentId.startsWith("trigger-response")) {
                        newEdges.push({
                            id: `e-${parentId}-${nodeId}`,
                            source: nodeId,
                            sourceHandle: sourceHandle,
                            target: parentId,
                            targetHandle: targetHandle,
                            type: "simplebezier",
                            style: { strokeWidth: 1, stroke: "#ffffff" },
                        });
                    } else {
                        newEdges.push({
                            id: `e-${parentId}-${nodeId}`,
                            source: parentId,
                            sourceHandle: sourceHandle,
                            target: nodeId,
                            targetHandle: targetHandle,
                            type: "simplebezier",
                            style: { strokeWidth: 1, stroke: "#ffffff" },
                        });
                    }
                }

                if (parentId === "source-response" || parentId.startsWith("source-response-")) {
                    newEdges.push({
                        id: `e-${parentId}-${nodeId}`,
                        source: parentId,
                        sourceHandle: sourceHandle,
                        target: nodeId,
                        targetHandle: targetHandle,
                        type: "simplebezier",
                        style: { strokeWidth: 1, stroke: "#ffffff" },
                    });
                }

                // Connect the root to its child
                if (parentId === "source-request") { // only the first level edges
                    // console.log(parentId)
                    newEdges.push({
                        id: `e-${parentId}-${nodeId}`,
                        source: nodeId,
                        sourceHandle: sourceHandle,
                        target: parentId,
                        targetHandle: targetHandle,
                        type: "simplebezier",
                        style: { strokeWidth: 1, stroke: "#ffffff" },
                    });
                }

                if (parentId === "destination-request" || parentId.startsWith("destination-request-")) {
                    newEdges.push({
                        id: `e-${parentId}-${nodeId}`,
                        source: nodeId,
                        sourceHandle: sourceHandle,
                        target: parentId,
                        targetHandle: targetHandle,
                        type: "simplebezier",
                        style: { strokeWidth: 1, stroke: "#ffffff" },
                    });
                }

                if (parentId === "destination-response" || parentId.startsWith("destination-response-")) {
                    newEdges.push({
                        id: `e-${parentId}-${nodeId}`,
                        source: parentId,
                        sourceHandle: sourceHandle,
                        target: nodeId,
                        targetHandle: targetHandle,
                        type: "simplebezier",
                        style: { strokeWidth: 1, stroke: "#ffffff" },
                    });
                }


                if (parentId === "trigger-response") {
                    // newEdges.push({
                    //     id: `e-${parentId}-${nodeId}`,
                    //     source: nodeId,
                    //     sourceHandle: sourceHandle,
                    //     target: parentId,
                    //     targetHandle: targetHandle,
                    //     type: "simplebezier",
                    //     style: { strokeWidth: 1, stroke: "#000" },
                    // });
                }

                nextY += nodeYIncrement;

                if (property.properties || property.items) {
                    // Get parent x position if available
                    const currentNode = newNodes.find(node => node.id === nodeId);
                    const parentX = currentNode ? currentNode.position.x : null;

                    let childSchema = property;
                    if (property.items) {
                        // Handle array items
                        if (property.items.length > 0) {
                            childSchema = property.items[0]; // Assuming only one item type in the array
                        } else {
                            childSchema = null;
                        }
                    }
                    if (childSchema) {
                        const newLevel = level + 1;
                        // console.log(newLevel)
                        // console.log(nodeId)
                        const { nodes: childNodes, edges: childEdges } = createNodesAndEdgesFromSchema(
                            childSchema,
                            nodeId,
                            xOffset,
                            newLevel,
                            nextY,
                            isSource,
                            nodeYIncrement,
                            sourceRootNodeX,
                            isTrigger,
                            isSourceRequest,
                            parentX // Pass the parent's X position
                        );
                        newNodes.push(...childNodes);
                        newEdges.push(...childEdges);
                        nextY += childNodes.length * 80;
                    }
                }
            } else {
                console.warn(`Property ${key} is undefined in schema:`, schema);
            }
        }
    } else {
        console.warn("Schema or schema.properties is undefined:", schema);
    }

    return { nodes: newNodes, edges: newEdges };
};

// Connection validation function
export const isValidConnection = (connection) => {
    const sourceNodeId = connection.source;
    const targetNodeId = connection.target;

    // Check if source and target nodes are in different sections
    const isSourceNode1 = sourceNodeId.startsWith("trigger") || sourceNodeId.startsWith("source-response") || sourceNodeId.startsWith("destination-response");
    const isTargetNode1 = targetNodeId.startsWith("data-translation");

    const isSourceNode2 = sourceNodeId.startsWith("data-translation");
    const isTargetNode2 = targetNodeId.startsWith("source-request") || targetNodeId.startsWith("destination-request") || targetNodeId.startsWith("trigger-response");

    // Ensure a boolean is always returned
    if ((isSourceNode1 && isTargetNode1) || (isSourceNode2 && isTargetNode2)) {
        return true;
    } else {
        return false;
    }
};
